import type { AuthRepository, SignUpCommand, SignUpResponse } from '../repository/AuthRepository';

export class SignUpUseCase {
  constructor(private readonly repository: AuthRepository) {}

  async execute(command: SignUpCommand): Promise<SignUpResponse> {
    // 모든 검증/정규화는 UseCase에서 수행 (TDD 타겟)
    const isOrganization = !!command.organization?.trim();
    // 단체 회원: organization만, first/last_name 비움
    // 개인 회원: first_name에만 전체 이름 입력, last_name은 빈 문자열 (리뉴얼 후 이름 통합)
    if (!command.first_name?.trim() && !isOrganization) throw new Error('first_name is required');
    if (!command.email?.trim()) throw new Error('email is required');
    if (!command.partner?.trim()) throw new Error('partner is required');
    if (!command.user_passwd) throw new Error('user_passwd is required');

    return this.repository.signUp({
      ...command,
      first_name: isOrganization ? '' : command.first_name.trim(),
      last_name: isOrganization ? '' : (command.last_name?.trim() ?? ''),
      email: command.email.trim(),
      partner: command.partner.trim(),
    });
  }
}


